export default __webpack_public_path__ + "static/media/tapicerowane12.f056f3cb.jpg";